<template>
    <b-col cols="6" :md="size">
        <b-card id="lib-file"  @click="selectFile($event, item)" v-bind:class="{ selected: isSelected(item.key), private: isPrivate}">
            <template v-if="itemsSelected.length == 1">
                <b-button type="submit" variant="success" @click="editFile" v-if="itemsSelected[0].key == item.key" class="edit-button"><i class="fa fa-pencil"></i></b-button>
            </template>

             <b-link :href="localUrl" @click="(e) => {e.stopImmediatePropagation()}" class="view-link" target="_blank"><i class="fa fa-eye"></i></b-link>
             <b-link @click="showShareModal" class="is-private" v-if="isPrivate"><i class="fa fa-lock" ></i></b-link>

            <div class="image_wrapper" @click="preview">
                <template v-if="showPreview">
                    <b-spinner v-if="blob == null" />
                    <img :src="`data:;base64,${blob}`" v-else/>
                </template>

                <span :class="`fiv-cla fiv-icon-${getFileExtension(item.name)}`" v-else></span>

            </div>
            <p>{{ formatName(item.name, 15) }}</p>
            <p><small>{{ item.ext }}</small></p>
        </b-card>

        <b-modal :title="formatName(item.name, 30)" v-model="fileModal.show" :hide-footer="true">
            <InputField name="local_url" :label="this.$t('localUrl')" :value="localUrl"
                :disabled=true
                :rules="{required:true, length: {min: 2}}"
            />

            <InputField name="public_url" :label="this.$t('publicUrl')" :value="item.public_url"
                :disabled=true
                :rules="{required:true, length: {min: 2}}"
                v-if="!isPrivate"
            />

            <InputField name="size" type="text" :label="this.$t('size')" :value="getFileModalSizeAndType()[0]"
                :disabled=true
                :rules="{required:true}"
                :sufix="getFileModalSizeAndType()[1]"
            />

            <InputField name="created_by" type="text" :label="this.$t('createdBy')" :value="item.created_by"
                :disabled=true
                :rules="{required:true}"
            />

            <b-form-group
                :label-cols="12"
                :horizontal="false">

                <template #label>
                    Metadata
                </template>
                
                <b-row v-for="metadata in Object.keys(item.metadata || {})" :key="metadata" class="mt-1">
                    <b-col cols="6">
                        <b-input placeholder="Key" :value="metadata" disabled/>
                    </b-col>

                    <b-col cols="6">
                        <b-input placeholder="Value" :value="item.metadata[metadata]" disabled/>
                    </b-col>
                </b-row>
            </b-form-group>
        </b-modal>

        <b-modal title="Share private file" v-model="privateModal.show" v-if="isPrivate" ok-only ok-title="Share" @ok="share" :hide-footer="privateModal.shareURL !== null">
            <SelectField name="roles" :label="this.$t('shareVia')" :description="this.$t('privateMedia')" v-model="privateModal.shareType"
                :items="privateModal.shareTypes"
                :rules="{required:false}"
            />

            <DateTimeField name="valid_until" :label="this.$t('validUntil')" :description="this.$t('shareLink')" v-model="privateModal.validUntil"
                :disablePastDates="true"
                :minuteStep="5"
                :rules="{required:false}"
            />

            <b-form-group
                v-if="privateModal.shareType == 'email'"
                :label="this.$t('emails')"
                label-for="emails"
                :label-cols="2"
                :label-cols-sm="2"
                :description="this.$t('emailsSeparated')"
                :horizontal="false">
                <b-textarea v-model="privateModal.emails" />
            </b-form-group>

            <InputField name="share_url" :label="this.$t('shareUrl')" :value="privateModal.shareURL"
                :disabled="true"
                :rules="{required:true, length: {min: 2}}"
                v-if="privateModal.shareURL !== null && privateModal.shareType == 'link'"
            />
        </b-modal>
    </b-col>
</template>

<style scoped lang="scss">
    @import "@/assets/scss/style.scss";
    @import "~file-icon-vectors/dist/file-icon-vectors.min.css";
    @import "~file-icon-vectors/dist/file-icon-classic.min.css";

    .fiv-cla {
        font-size: 100px;
        margin-top: 25px;
    }

    img {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;
    }

    #lib-file .btn-success {
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 0;
        padding: 3px 6px;
    }

    #lib-file .view-link {
        position: absolute;
        left: 0;
        bottom: 0;
        margin: 5px;
        opacity: 0.7;
    }

     #lib-file .is-private {
        position: absolute;
        right: 0;
        bottom: 0;
        margin: 5px;
        opacity: 0.7;
    }

    #lib-file .image_wrapper {
        width: 100%;
        position: relative;
        height: 150px;
        overflow: hidden;
    }

    #lib-file.private {
        border: 1px solid $warning;
    }

    #lib-file, #lib-dir {
        overflow: hidden;
    }

    #lib-file > .card-body {
        padding: 5px;
    }

    #lib-file.selected {
        border: 2px solid #20a8d8 !important;
    }

    #lib-file p {
       display: block;
       margin: 0;
       padding: 5px;
    }

    #lib-file .edit-button {
        z-index: 999;
    }

    #lib-file {
        text-align: center;
    }

    #lib-dir i {
        float: left;
        padding: 0px 15px 0px 0px;
    }

    #lib-dir p {
        padding: 5px 0px 0px 0px;
        margin: 0;
    }
</style>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import DateTime from "@/components/form/DateTime"
import { truncate } from 'lodash'

export default {
    components: {
        InputField: Input,
        SelectField: Select,
        DateTimeField: DateTime
    },
    props: {
        file: {
            type: Object
        },

        library: {
            type: Object
        },

        itemsSelected: {
            type: Array
        },

        public: {
            type: Boolean
        },
        
        size: {
            type: Number,
            default: 2
        }
    },

    data: function() {
        return {
            item: this.file,
            fileModal: {
                show: false,
                title: '',
                data: {}
            },
            blob: null,
            showPreview: false,
            privateModal: {
                show: false,
                shareURL: null,
                shareType: 'link',
                shareTypes: ['link', 'email'],
                validUntil: '',
                emails: ''
            }
        }
    },

    computed: {
        localUrl() {
            return this.file.local_url
        },

        isPrivate() {
            return !this.public
        }
    },

    methods: {
        selectFile(event, item) {
            this.$emit('selectFile', event, item)
        },

        getFileModalSizeAndType() {
            let size = this.item.size / 1024
            if (size < 1024) {
                return [size.toFixed(2), "KB"]
            }

            size = size / 1024
            if (size < 1024) {
                return [size.toFixed(2), "MB"]
            }

            return [size.toFixed(2), "B"];
        },

        preview() {
            if (!this.isFileImage(this.file)) return
            this.showPreview = true;
            this.$mediaHttp.get("/v1/media/library/" + this.library.uuid + "/get/" + this.file.key, {responseType: 'arraybuffer' }).then(resp => {
                const base64 = btoa(
                    new Uint8Array(resp.data).reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        '',
                    ),
                    );

                this.blob = base64
            }).catch(error => {
                //
                console.log(error)
            })
        },

        saveEditFile() {
            this.$mediaHttp.post("/v1/media/edit/" + this.fileModal.data.uuid, this.fileModal.data).then(resp => {
                //console.log(resp)
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$bvModal.msgBoxOk(error.response.message)
            })
        },

        share(e) {
            if (this.privateModal.shareType == 'link')
                e.preventDefault();

            this.$mediaHttp.post("/v1/media/library/" + this.library.uuid + "/share", {key: this.file.key, date: this.privateModal.validUntil}).then(resp => {
                //console.log(resp)
                this.privateModal.shareURL = resp.data
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$bvModal.msgBoxOk(error.response.message)
            })
        },

         editFile() {
            this.fileModal.show = true
        },

        isSelected(key) {
            return this.itemsSelected.find(i => {
                return i.key == key
            })
        },

        getFileExtension(name) {
            let l = name.split(".")

            return l[l.length - 1]
        },

        isFileImage(item) {
            let ext = this.getFileExtension(item.name)

            return ext == 'jpg' || ext == 'jpeg' || ext == 'png' || ext == 'webp' || ext == 'gif'
        },

        showShareModal() {
            this.privateModal.show = true
            this.privateModal.shareURL = null
            this.privateModal.validUntil = null
        },

        formatName(name, p) {
            return truncate(name, {
                omission: '...',
                length: p || 10
            })
        }
    }
}
</script>
